import { Component, Input, Output, EventEmitter, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CotizacionData, CotizacionFormValues } from '../../../core/models/cotizador.model';

@Component({
  selector: 'app-cotizacion',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './cotizacion.component.html'
})
export class CotizacionComponent implements OnInit {
  @Input({ required: true }) cotizacion!: CotizacionData;
  @Output() onCotizar = new EventEmitter<CotizacionFormValues>();
  @Output() onRegresar = new EventEmitter<void>();

  reahorro = signal<boolean>(false);
  ahorroMensualCot = signal<string>('');
  mensajeError = signal<string | null>(null);
  mostrarModal = signal<boolean>(false);
  propsModal = signal<{ exito: boolean; texto: string }>({ exito: false, texto: '' });

  ngOnInit(): void {
    window.scrollTo(0, 0);
    if (this.cotizacion?.values?.ahorro_mensual) {
      this.ahorroMensualCot.set(this.cotizacion.values.ahorro_mensual);
    }
    this.opcionMedidaTexto(this.cotizacion);
  }

  private opcionMedidaTexto(cotizacion: CotizacionData): void {
    if (cotizacion?.opcionMedida?.texto) {
      this.propsModal.set({ exito: false, texto: cotizacion.opcionMedida.texto });
      this.mostrarModal.set(true);
    }
  }

  get ahorroMensualNumber(): number {
    return parseInt(this.cotizacion?.values?.ahorro_mensual || '0', 10);
  }

  onInputChange(value: string): void {
    this.mostrarModal.set(false);
    this.mensajeError.set(null);
    this.ahorroMensualCot.set(value);
  }

  muestraAhorro(): void {
    this.reahorro.set(true);
    this.mostrarModal.set(false);
  }

  regresar(): void {
    window.location.reload();
  }

  cotizar(): void {
    if (this.valida()) {
      const values: CotizacionFormValues = {
        ...this.cotizacion.values,
        ahorro_mensual: this.ahorroMensualCot(),
        aportaciones: this.cotizacion.aportaciones
      };
      this.onCotizar.emit(values);
    }
  }

  recotizar(): void {
    this.mostrarModal.set(false);
    if (this.valida()) {
      const values: CotizacionFormValues = {
        ...this.cotizacion.values,
        ahorro_mensual: this.ahorroMensualCot(),
        aportaciones: this.cotizacion.aportaciones,
        recotiza: true
      };
      this.onCotizar.emit(values);
    }
  }

  valida(): boolean {
    this.mensajeError.set(null);
    const val = this.ahorroMensualCot();

    if (!val || val.trim() === '') {
      this.mensajeError.set('Campo requerido.');
      return false;
    }

    const regex = /^\d{2,6}$/;
    if (!regex.test(val)) {
      this.mensajeError.set('Capture un ahorro mensual válido.');
      return false;
    }

    const numVal = parseInt(val, 10);
    if (numVal < 1000 || numVal > 150000) {
      this.mensajeError.set('El ahorro mensual mínimo es de $1,000 pesos y máximo de $150,000 pesos.');
      return false;
    }

    return true;
  }

  formatCurrency(e: any): string {
    if (e === null || e === undefined) return '0';
    let str = e.toString().replace(/\$|,/g, '');
    let val = parseFloat(str);

    if (isNaN(val)) return '0';

    let sign = val >= 0;
    val = Math.abs(val);

    let eInt = Math.floor(100 * val + 0.50000000001);
    let cents = (eInt % 100).toString();
    let numStr = Math.floor(eInt / 100).toString();

    if (parseInt(cents, 10) < 10) cents = '0' + cents;

    for (let t = 0; t < Math.floor((numStr.length - (1 + t)) / 3); t++) {
      numStr = numStr.substring(0, numStr.length - (4 * t + 3)) + ',' + numStr.substring(numStr.length - (4 * t + 3));
    }

    return (sign ? '' : '-') + numStr;
  }
}